import React, { useRef } from 'react';
import SbEditable from 'storyblok-react';
import FluidImage from 'src/utils/FluidImage';
import RichText from 'src/utils/RichText';
import Label from 'src/components/Label';
import Heading from 'src/components/Heading';
import InView from 'src/utils/InView';

const TestimonialWithBackgroundImage = ({ blok }) => {
    const ref = useRef();
    const isVisible = InView(ref, true);

    return (
        <SbEditable content={blok} key={blok._uid}>
            <div className="py-14 sm:py-20 bg-white">
                <div className="max-w-7xl mx-auto px-6 2xl:max-w-screen-2xl">
                    <div
                        className={`relative shadow-xl rounded-xl duration-500 opacity-0 translate-y-10 ${isVisible && 'opacity-100 !translate-y-0'}`}
                        ref={ref}
                    >
                        <FluidImage image={blok.image} className={`${blok.mobile_image?.filename ? 'md:block hidden' : ''} w-full h-full object-cover rounded-xl`} />
                        {blok.mobile_image?.filename && (
                            <FluidImage image={blok.mobile_image} className="md:hidden block w-full h-full object-cover rounded-xl" />
                        )}
                        <FluidImage image={blok.logo} className={`${blok.mobile_image?.filename ? 'md:block hidden' : ''} w-full h-full object-cover rounded-xl this`} />
                        {blok.mobile_image?.filename && (
                            <FluidImage image={blok.mobile_image} className="md:hidden block w-full h-full object-cover rounded-xl" />
                        )}
                        <div className="md:px-20 px-6 absolute -translate-y-1/2 top-1/2 left-0">
                            <Label className="text-white opacity-50 md:mb-6 mb-4">{blok.label}</Label>
                            <Heading size="h5" className="text-white prose max-w-lg full-bold font-normal !leading-[1.8rem]">
                                <RichText>{blok.description}</RichText>
                            </Heading>
                        </div>
                    </div>
                </div>
            </div>
        </SbEditable>
    );
};

export default TestimonialWithBackgroundImage;
